var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2017 17.7793C14.3439 17.7793 17.7017 14.4214 17.7017 10.2793C17.7017 6.13716 14.3439 2.7793 10.2017 2.7793C6.05959 2.7793 2.70172 6.13716 2.70172 10.2793C2.70172 14.4214 6.05959 17.7793 10.2017 17.7793Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2017 12.7376C11.5195 12.7376 12.5878 11.637 12.5878 10.2794C12.5878 8.92184 11.5195 7.82129 10.2017 7.82129C8.88394 7.82129 7.81567 8.92184 7.81567 10.2794C7.81567 11.637 8.88394 12.7376 10.2017 12.7376Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/Donut.8e3afc9fb093552b76cf4199834965bf.svg";
export { ForwardRef as ReactComponent };